import { render, staticRenderFns } from "./FormRender.vue?vue&type=template&id=7c6e874e&scoped=true"
import script from "./FormRender.vue?vue&type=script&lang=js"
export * from "./FormRender.vue?vue&type=script&lang=js"
import style0 from "./FormRender.vue?vue&type=style&index=0&id=7c6e874e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6e874e",
  null
  
)

export default component.exports